import "./couponForm.css";
import { useState } from 'react';
import { useCreateCouponMutation } from '../../services/couponApi'
import { useNavigate } from "react-router-dom";
import { AdminPageHeader, AdminCard, AdminInput, AdminSelect, LoadingButton, useToast } from '../../components/ui'

const NewCoupon = () => {
  const navigate = useNavigate();
  const [server_error, setServerError] = useState({})
  const [createCoupon, { isLoading }] = useCreateCouponMutation()
  const [discountType, setDiscountType] = useState('PERCENT')
  const toast = useToast();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const actualData = {
      code: data.get("code"),
      discount_type: discountType,
      value: data.get("value"),
      min_order_amount: data.get("min_order_amount") || 0,
      max_uses: data.get("max_uses") || null,
      valid_until: data.get("valid_until") || null,
      is_active: data.get("is_active") === "on",
    };

    const res = await createCoupon(actualData);
    if (res.error) {
      setServerError(res.error.data?.errors || {});
      toast.error("Could not create this coupon. Check the fields below.");
    }
    if (res.data) {
      toast.success("Coupon added successfully.");
      setTimeout(() => navigate('/admin/coupons'), 1200);
    }
  };

  return (
    <div>
      <AdminPageHeader
        title="New Coupon"
        breadcrumbs={[{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Coupons", to: "/admin/coupons" }, { label: "New" }]}
      />
      <AdminCard className="couponForm">
        <form onSubmit={handleSubmit}>
          <AdminInput label="Coupon Code" name="code" placeholder="e.g. WELCOME10" error={server_error.code?.[0]} required />
          <AdminSelect label="Discount Type" value={discountType} onChange={(e) => setDiscountType(e.target.value)}>
            <option value="PERCENT">Percentage</option>
            <option value="FLAT">Flat Amount</option>
          </AdminSelect>
          <AdminInput label={`Value (${discountType === 'PERCENT' ? '%' : '₹'})`} type="number" step="0.01" name="value" error={server_error.value?.[0]} required />
          <AdminInput label="Minimum Order Amount (optional)" type="number" step="0.01" name="min_order_amount" placeholder="0" />
          <AdminInput label="Max Uses (optional, blank = unlimited)" type="number" name="max_uses" />
          <AdminInput label="Valid Until (optional)" type="datetime-local" name="valid_until" />
          <label className="couponForm__checkbox">
            <input type="checkbox" name="is_active" defaultChecked /> Active
          </label>
          <div className="couponForm__actions">
            <LoadingButton type="submit" loading={isLoading} loadingLabel="Creating...">Create Coupon</LoadingButton>
          </div>
        </form>
      </AdminCard>
    </div>
  );
}

export default NewCoupon
